import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  CircularProgress,
  Alert,
  Button
} from '@mui/material';
import { CheckCircle as CheckCircleIcon } from '@mui/icons-material';
import { useNavigate, useSearchParams } from 'react-router-dom';

const BillingComplete: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Check the setup intent status
    const redirectStatus = searchParams.get('redirect_status');

    if (redirectStatus === 'succeeded') {
      setStatus('success');
      setMessage('Your billing setup is complete! Your 30-day free trial has begun.');
      
      // Clean up localStorage
      localStorage.removeItem('pendingOrganizationName');
      localStorage.removeItem('pendingOrganizationId');
      localStorage.removeItem('pendingSubscriptionTier');
      localStorage.removeItem('pendingBillingFrequency');
      localStorage.removeItem('pendingSelectedToolkit');
      
      // Redirect to dashboard after a short delay
      setTimeout(() => {
        navigate('/dashboard');
      }, 3000);
    } else {
      setStatus('error');
      setMessage('There was an issue setting up your billing. Please try again.');
    }
  }, [searchParams, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#fafafa',
      }}
    >
      <Card style={{ maxWidth: 600, width: '100%', marginLeft: 16, marginRight: 16 }}>
        <CardContent style={{ textAlign: 'center', paddingTop: 40, paddingBottom: 40 }}>
          {status === 'loading' && (
            <>
              <CircularProgress size={60} style={{ marginBottom: 24 }} />
              <Typography variant="h5" gutterBottom>
                Processing your setup...
              </Typography>
              <Typography color="text.secondary">
                Please wait while we complete your billing setup.
              </Typography>
            </>
          )}

          {status === 'success' && (
            <>
              <CheckCircleIcon
                style={{
                  fontSize: 80,
                  color: '#2e7d32',
                  marginBottom: 24,
                }}
              />
              <Typography variant="h4" gutterBottom>
                Welcome to Prismatic Forge!
              </Typography>
              <Alert severity="success" style={{ marginTop: 24, marginBottom: 24 }}>
                {message}
              </Alert>
              <Typography color="text.secondary" paragraph>
                You'll be redirected to your dashboard in a few seconds...
              </Typography>
              <Button 
                variant="contained" 
                onClick={() => navigate('/dashboard')}
                style={{ marginTop: 16 }}
              >
                Go to Dashboard Now
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <Alert severity="error" style={{ marginBottom: 24 }}>
                {message}
              </Alert>
              <Button 
                variant="contained" 
                onClick={() => navigate('/billing/setup')}
              >
                Try Again
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingComplete;